// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mq-0";
export var assigneeDetails = "_mq-1";
export var assigneeInfo = "_mq-2";
export var dropdownContainer = "_mq-4";
export var dropdownImage = "_mq-5";
export var editAssigneeInfo = "_mq-3";
export var editAssigneeModalContainer = "_mq-6";
export var hidden = "_mq-8";
export var input = "_mq-7";